import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { FetchMonthsReport } from "./../../../domain/useages/user-summary-report/fetch-months-report";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import { RemoteFetchMonthsReport } from "../../../data/usecases/user-summary-report/remote-fetch-months-report";
import Endpoints from "../../../domain/endpoints";
import { MonthsReportType } from "../../../domain/models/user-summary-report/months-report";
import { FetchState } from "../../../domain/models/fetch-state";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchMonthsReportInterface {
  fetchMonthsReport: Function;
  monthsReportData: MonthsReportType;
  monthsReportDataState: FetchState;
}

const initialStates = {
  monthsReportData: {} as MonthsReportType,
  monthsReportDataState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchMonthsReportSlice: StateCreator<
  FetchMonthsReportInterface
> = (set, get) => ({
  ...initialStates,
  fetchMonthsReport: async (
    year: number,
    user_id: number,
    department_id: number
  ) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);
    set({ monthsReportDataState: FetchState.LOADING });

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchMonthsReport: FetchMonthsReport =
      new RemoteFetchMonthsReport(
        `${BASE_URL}${Endpoints.MONTHS_REPORT}`,
        axiosHttpClient
      );
    let result = await remoteFetchMonthsReport.fetch(
      year,
      user_id,
      department_id
    );

    if (result.orders.length != 0 || result.all_visits.length != 0) {
      set({
        monthsReportData: result,
        monthsReportDataState: FetchState.SUCCESS,
      });
    } else if (result.orders.length === 0) {
      set({
        monthsReportData: result,
        monthsReportDataState: FetchState.ERROR,
      });
    }
  },
});
